'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const init_1 = require("./class/init");
const common_1 = require("./class/common");
const photo_1 = require("./class/photo");
const ajax_1 = require("./class/ajax");
$(() => {
    new init_1.default();
    new common_1.default();
    new photo_1.default();
    new ajax_1.default();
});
